module.exports = __webpack_public_path__ + "static/media/multi-2.baea0a44.png";